import React from 'react'
import {
  DocumentTypeContainer,
  DocumentTypeButton,
  Icon,
  RadioInput,
} from '../../styles/PrepareEsignModalElements'
import { DocSelectionTypes } from '../PrepareDocuSignModal'

const PrepareDocumentType = ({
  isTemplateType,
  isFileType,
  setDocSelection,
  setCustomFileInfo,
}) => (
  <DocumentTypeContainer>
    <DocumentTypeButton
      active={isTemplateType}
      key={DocSelectionTypes.TEMPLATE}
      onClick={() => {
        setDocSelection(DocSelectionTypes.TEMPLATE)
        setCustomFileInfo(null)
      }}
    >
      <RadioInput type="radio" checked={isTemplateType} />
      <Icon
        active={isTemplateType}
        className="fa fa-file-text"
        color="inherit"
      />
      Use a SmartBiz template
    </DocumentTypeButton>
    <DocumentTypeButton
      active={isFileType}
      key={DocSelectionTypes.FILE}
      onClick={() => setDocSelection(DocSelectionTypes.FILE)}
    >
      <RadioInput type="radio" checked={isFileType} />
      <Icon active={isFileType} className="fa fa-upload" color="inherit" />
      Upload a custom document
    </DocumentTypeButton>
  </DocumentTypeContainer>
)

export default PrepareDocumentType
